// @ts-nocheck
import React, { useEffect } from "react";

const TrustBox = () => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);
  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <>
      <div
        ref={ref} // We need a reference to this element to load the TrustBox in the effect.
        className="trustpilot-widget w-full hidden md:block"
        data-locale="en-GB"
        data-template-id="53aa8912dec7e10d38f59f36"
        data-businessunit-id="6241a77ac40663fab1b7b56d"
        data-style-height="140px"
        data-style-width="100%"
        data-theme="light"
        data-tags="masterclass"
        data-stars="5"
        data-review-languages="en"
      >
        <a
          href="https://www.trustpilot.com/review/example.com"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          Trustpilot
        </a>
      </div>
      <div className="md:hidden w-4/5 mx-auto">
        <div
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="539ad0ffdec7e10e686debd7"
          data-businessunit-id="6241a77ac40663fab1b7b56d"
          data-style-height="350px"
          data-style-width="100%"
          data-theme="light"
          data-tags="masterclass"
          data-stars="5"
          data-review-languages="en"
        >
          <a
            href="https://uk.trustpilot.com/review/turtlemethod.com"
            target="_blank"
            rel="noreferrer"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </>
  );
};
export default TrustBox;
